import React, { useState, useEffect } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  TextField,
  Button,
  Alert,
  IconButton,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import { API_BASE_URL } from '../config'; // 导入API基础URL

const RechargeConfig = () => {
  const [wechat, setWechat] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', content: '' });
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    fetchWechatConfig();
  }, []);

  const fetchWechatConfig = async () => {
    try {
      const token = localStorage.getItem('authToken');
      console.log('[客服配置] 开始获取配置, token:', token ? '存在' : '不存在');

      if (!token) {
        setMessage({
          type: 'error',
          content: '认证失败: 未找到登录令牌'
        });
        setInitialLoading(false);
        return;
      }

      // 使用完整的后端API地址
      const apiUrl = `${API_BASE_URL || ''}/kOjtx3AXNmCsT5Wz/recharge/info`;
      console.log('[客服配置] 请求URL:', apiUrl);

      const response = await fetch(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      console.log('[客服配置] 响应状态:', response.status);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('[客服配置] 获取到的数据:', data);

      if (data.wechat) {
        setWechat(data.wechat);
      }
    } catch (error) {
      console.error('[客服配置] 获取失败:', error);
      setMessage({
        type: 'error',
        content: '获取配置失败: ' + (error.message || '未知错误')
      });
    } finally {
      setInitialLoading(false);
    }
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      console.log('[客服配置] 开始保存配置:', wechat);

      if (!token) {
        throw new Error('认证失败: 未找到登录令牌');
      }

      // 使用完整的后端API地址
      const apiUrl = `${API_BASE_URL || ''}/kOjtx3AXNmCsT5Wz/recharge/info`;
      console.log('[客服配置] 保存请求URL:', apiUrl);

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ wechat })
      });

      console.log('[客服配置] 保存响应状态:', response.status);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('[客服配置] 保存响应:', data);

      setMessage({
        type: 'success',
        content: data.message || '保存成功'
      });
    } catch (error) {
      console.error('[客服配置] 保存失败:', error);
      setMessage({
        type: 'error',
        content: '保存失败: ' + (error.message || '未知错误')
      });
    } finally {
      setLoading(false);
    }
  };

  if (initialLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Card sx={{ bgcolor: 'rgba(0, 30, 60, 0.5)', border: '1px solid rgba(255, 255, 255, 0.1)' }}>
      <CardContent>
        {message.content && (
          <Alert
            severity={message.type}
            sx={{
              mb: 3,
              bgcolor: message.type === 'success' ? 'rgba(0, 255, 159, 0.1)' : 'rgba(211, 47, 47, 0.1)',
              color: message.type === 'success' ? '#00ff9f' : '#ff5252'
            }}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => setMessage({ type: '', content: '' })}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {message.content}
          </Alert>
        )}

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom sx={{ color: '#fff' }}>
            客服微信配置
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.5)', mb: 2 }}>
            设置用户联系客服的微信号
          </Typography>
          <TextField
            fullWidth
            label="客服微信号"
            value={wechat}
            onChange={(e) => setWechat(e.target.value)}
            placeholder="请输入客服微信号"
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.23)',
                },
                '&:hover fieldset': {
                  borderColor: '#00ff9f',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#00ff9f',
                },
              },
              '& .MuiInputLabel-root': {
                color: 'rgba(255, 255, 255, 0.7)',
              },
              '& .MuiInputBase-input': {
                color: '#fff',
              },
            }}
          />
        </Box>

        <Box display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : <SaveIcon />}
            sx={{
              bgcolor: '#00ff9f',
              color: '#000',
              '&:hover': {
                bgcolor: '#00cc7f'
              },
              '&:disabled': {
                bgcolor: 'rgba(0, 255, 159, 0.3)'
              }
            }}
          >
            {loading ? '保存中...' : '保存配置'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default RechargeConfig; 